import React, { useRef, useState } from 'react';

function PopupBtmAddRequest({ setisShowAddRequest, setisCompleteAddRequest, carInfo, setcarInfo }) {
  const [request, setRequest] = useState(carInfo.userRequest || '');
  const maxLength = 300;

  const handleRequestChange = (e) => {
    const value = e.target.value;
    if (value.length <= maxLength) {
      setRequest(value);
    }
  };

  const handleComplete = () => {
    if (request.trim()) {
      setcarInfo({
        ...carInfo,
        userRequest: request
      });
      setisCompleteAddRequest(true);
      setisShowAddRequest(false);
    }
  };




  // 스와이프 관련 상태
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const dragHandleRef = useRef(null); // 드래그 핸들(상단 바)을 위한 ref
  
    const minSwipeDistance = 50;
  
    const onTouchStart = (e) => {
      // dragHandleRef가 터치 이벤트의 시작점을 포함하고 있는지 확인
      if (dragHandleRef.current?.contains(e.target)) {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientY);
      }
    };
  
    const onTouchMove = (e) => {
      // touchStart가 있을 때만 동작 (즉, 드래그 핸들에서 시작된 터치일 때만)
      if (touchStart) {
        setTouchEnd(e.targetTouches[0].clientY);
      }
    };
  
    const onTouchEnd = () => {
      if (!touchStart || !touchEnd) return;
      
      const distance = touchEnd - touchStart;
      const isDownSwipe = distance > minSwipeDistance;
      
      if (isDownSwipe) {
        setisShowAddRequest(false);
      }
    };

    

  return (
    <div className="fixed bg-[rgba(0,0,0,0.7)] top-0 left-0 w-full h-full flex items-end justify-center z-10">
      <div 
        className="bg-white w-full pb-5 pt-10 min-h-64 rounded-t-2xl max-w-screen-md max-h-[calc(100%-67px)] overflow-y-auto relative px-5"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        {/* 드래그 핸들 영역에 ref 추가 */}
        <button 
          ref={dragHandleRef}
          className="absolute top-0 left-0 flex justify-center w-full h-10 pt-4 m-auto rounded-xl"
        >
          <span className="w-10 h-1 bg-[#E1E2E4] rounded-xl"></span>
        </button>

        <h3 className="text-[#1B1C1E] text-left font-semibold text-[22px] mb-4">
          요청사항을 입력해주세요
        </h3>

        <div className="flex-1">
          <textarea
            value={request}
            onChange={handleRequestChange}
            placeholder="요청사항을 300자 이내로 입력해주세요."
            className="w-full h-32 p-4 border border-[#E1E2E4] rounded-lg resize-none text-[15px] focus:outline-none focus:border-[#313A4C]"
          />
          <div className="relative flex justify-end mt-2">
            <span className="text-[12px] text-[#8E8E93] absolute bottom-7 right-4">
              {request.length} / {maxLength}
            </span>
          </div>
        </div>

        <div className="flex justify-between mt-8 gap-[10px]">
          <button
            className="flex items-center justify-center w-full h-[52px] rounded-lg bg-[#F4F4F5] text-[#313A4C] font-semibold"
            onClick={() => setisShowAddRequest(false)}
          >
            취소
          </button>
          <button
            className={`flex items-center justify-center w-full h-[52px] rounded-lg ${
              request.trim() ? 'bg-[#313A4C]' : 'bg-[#E1E2E4]'
            } text-white font-semibold`}
            onClick={handleComplete}
            disabled={!request.trim()}
          >
            완료
          </button>
        </div>
      </div>
    </div>
  );
}

export default PopupBtmAddRequest;